import {Component, EventEmitter, Input, Output, TemplateRef, ViewChild, ChangeDetectionStrategy} from "@angular/core";
import {ActiveConsumptionPeriod} from "../../../models/rt2012/activeConsumptionPeriod";
import {EnergieService} from "../../../services/rt2012/energie.service";
import {faTimes, faPen, faPlus} from '@fortawesome/free-solid-svg-icons';
import {EnergieEnum} from "../suivi-des-consommations/enums/EnergieEnum";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {rubberBandOnEnterAnimation} from '../../../animations';
import {Logement} from "../../../models/logement";
import {
  ActiveConsumptionPeriodService
} from "../../../services/rt2012/active-consumption-period/active-consumption-period.service";

@Component({
    selector: 'app-active-consumption-period',
    templateUrl: './active-consumption-period.html',
    styleUrls: ['./active-consumption-period.scss'],
    animations: [
        rubberBandOnEnterAnimation()
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ActiveConsumptionPeriodComponent {
  @Input() activeConsumptionPeriods: ActiveConsumptionPeriod[];
  @Input() energy: EnergieEnum;
  @Input() logement: Logement;

  @Output() periodRefreshed = new EventEmitter();

  @ViewChild('modalPeriod') modalEditReleveTemplate: TemplateRef<any>;

  editPeriod: ActiveConsumptionPeriod;
  editModal: NgbModalRef;
  faTimes = faTimes;
  faPen = faPen;
  faPlus = faPlus;
  public isEditable = true;
  EnergieEnum = EnergieEnum;

  public constructor(
    public energieService: EnergieService,
    public modalService: NgbModal,
    private activeConsumptionPeriodService: ActiveConsumptionPeriodService
  ) {
  }

  public edit(period) {
    this.editPeriod = period;
    this.editModal = this.modalService.open(this.modalEditReleveTemplate, {size: 'lg'});
  }

  onRefresh() {
    this.periodRefreshed.emit();
    this.editModal.close();
  }

  newPeriod() {
    this.editPeriod = new ActiveConsumptionPeriod();
    this.modalService.open(this.modalEditReleveTemplate, {size: 'lg'})
  }

  delete(period) {
    this.activeConsumptionPeriodService.delete(period, this.logement, this.energy).then(() => {
      this.onRefresh()
    });

  }
}
